// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Reviews snapshot 1`] = `
<div class="reviews">
  <div class="row">
    <!---->
    <div class="filter">
      <div class="xs-12 sm-5 md-4 lg-3">
        <dropdown-stub label="Sort By">
          <option value=""></option>
          <option value="">DATE (Recent - Oldest)</option>
          <option value="">DATE (Oldest - Recent)</option>
          <option value="">RATING (Highest - Lowest)</option>
          <option value="">RATING (Lowest - Highest)</option>
          <option value="">MOST HELPFUL</option>
        </dropdown-stub>
      </div>
    </div>
  </div>
  <div class="review-page row"></div>
  <div class="pagination row">
    <!----><span>&nbsp;1/0&nbsp;</span>
    <router-link-stub to="[object Object]" tag="a" event="click" class="next"><span class="next-text">Next</span><i class="icon-caret-right"><span class="ada-tooltip">caret right icon</span></i></router-link-stub>
  </div>
</div>
`;
